import React from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { useHistory } from 'react-router';
import aboutAutzu from '../../../images/about-autzu.svg';
import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import TorontoFooter from '../../Layout/TorontoFooter';
import SFFooter from '../../Layout/SFFooter';
import NYCFooter from '../../Layout/NYCFooter';
import { Helmet } from 'react-helmet';

const AboutUs = props => {
  const history = useHistory();
  const isMobile = window.innerWidth < 768;

  return (
    <Fragment>
      <Helmet>
        <title>Autzu | About US</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="resourcePageWide container">
        <div className="backToNewsroom">
          <FontAwesomeIcon
            className="backButton"
            icon={faArrowLeft}
            onClick={evt => {
              history.push('/');
              evt.stopPropagation();
            }}
          />
          <div
            onClick={() => {
              history.push('/');
            }}>
            Back
          </div>
        </div>
        <div className="resourceTitle">About Autzu</div>
        <img src={aboutAutzu} className="aboutAutzuImg"></img>
        <div className="aboutTextContainer">
          <div className="aboutSubTitle">About Autzu</div>
          <div className="aboutContent">
            Autzu is a forward-thinking mobility technology company
            dedicated to creating a sustainable, efficient, and accessible
            transportation system for all. We develop and deploy
            cutting-edge technology for electric autonomous vehicles,
            providing necessary charging and maintenance infrastructure,
            and maximizing the utilization of vehicles through multiple
            dispatching platforms. Our innovative solutions aim to
            revolutionize urban mobility, reduce carbon emissions, and
            improve the quality of life in cities worldwide.
          </div>
        </div>
        <div
          className="aboutTextContainer"
          style={{
            borderBottom: isMobile ? '1px solid #414141' : 'none'
          }}>
          <div className="aboutSubTitle">Mission statement</div>
          <div className="aboutContent">
            Our mission is to revolutionize the transportation industry by
            developing and deploying cutting-edge technology that creates a
            sustainable, efficient, and accessible transportation system
            for all. We strive to reduce urban carbon emissions,
            congestion, and ultimately improve the quality of life in
            cities by mass deploying electric autonomous vehicles,
            providing necessary charging and maintenance infrastructure,
            and maximizing the utilization of vehicles through multiple
            dispatching platforms.
          </div>
        </div>
      </div>
      {/* <div className="greyframe goalVisionRedirectContainer">
        <div className="goalVision">
          Learn more about our goals and vision
        </div>
        <Link to="/goal">
          <button style={{ width: '180px' }}>Goals and vision</button>
        </Link>
      </div> */}
      <TorontoFooter />
    </Fragment>
  );
};

export default AboutUs;



// WEBPACK FOOTER //
// ./src/components/Newsroom/AboutUs/index.js